import React, { FunctionComponent } from 'react';
import { Collapse } from 'antd';
import DesignText from '@/components/typography/DesignText';
import PrismicRichText from '@/components/design/PrismicRichText';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import styles from './FaqPanel.module.scss';

interface IProps {
  questionText: string;
  answerText: IPrismicRichTextElement[];
  panelKey: string;
}

const FaqPanel: FunctionComponent<IProps> = ({ questionText, answerText, panelKey }) => (
  <div className={styles.FaqPanel}>
    <Collapse>
      <Collapse.Panel key={panelKey} header={<DesignText strong>{questionText}</DesignText>}>
        <PrismicRichText items={answerText} />
      </Collapse.Panel>
    </Collapse>
  </div>
);

export default FaqPanel;
